import React from 'react';
import style from './_form.scss';
import {Textarea} from 'components/danangtrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {Conversations} from 'api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

class CreateConversationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      content: '',
      isSubmit: false,
      id: this.props.id
    };

    this.props.validators['formConversation'] = [];
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.state.id) {
      this.setState({
        id: nextProps.id
      });
    }
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formConversation'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {content} = this.state;
      const data = {
        content
      };
      this.setState({isSubmit: true});

      Conversations.actions.send.request(null, {
        data: {
          message: this.state.content,
          ...this.props.data
        }
      }).then(response => {
        // console.log(response)
        this.props.onConversationCreate(response.data);
      }).finally(() => {
        this.setState({isSubmit: false});
      });
    }
  }

  render() {
    const {image, content, isSubmit, categories} = this.state;
    return (
      <section className="content">
        <section className="conversation-form">
          <form method="POST" onSubmit={this.onSubmit} noValidate>
            <div className="conversation-form-wrap-form">
              <div className="conversation-form-left-content">

                <Textarea type="text" placeholder="Nội dung tin nhắn..."
                  heading={
                    () => <h3 className='wrap-product-des-title'>Nội dung <span className='des-title-des'><i className='fa fa-info-circle'/>Giới hạn trong 300 kí tự.</span></h3>
                  }
                  className="wrap-product-des"
                  inputClassName="product-des-input"
                  iconFontSet='glyphicon'
                  iconClassName='glyphicon-user'
                  required={true}
                  rows={3}
                  maxLength={300}
                  name="content"
                  value={content}
                  onChange={this.onChange}
                  bindValidator={this} channel="formConversation"
                  errorMessage="Bạn vui lòng nhập nội dung gửi đi"
                />
              </div>
            </div>
            <div className="select-category-wrap">
              <div className="box-wrap box-padding-20">
                <LaddaButton className="update-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi đi</LaddaButton>
              </div>
            </div>
          </form>
        </section>
      </section>
    );
  }
}

CreateConversationForm.defaultProps = {
  validators: {}
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(mapStateToProps)(CreateConversationForm));



// WEBPACK FOOTER //
// ./components/conversations/CreateConversationForm.jsx